module.exports = __webpack_public_path__ + "static/media/_united-nations.55afd625.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/country-flags/_united-nations.svg
// module id = 2359
// module chunks = 7